// 路径规划RoutingV8
import service from "@/utils/request";

export function calculaterouteRoutingV8(params, paramStrings, cancelToken) {
  return service({
    baseURL: process.env.VUE_APP_HERE_ROUTING_API,
    url: `/v8/routes?${paramStrings.join('&')}`,
    method: 'get',
    params: params,
    headers: {
      'disable-token': true
    },
    cancelToken
  })
}

export function getDistance(params) {
  return service({
    baseURL: process.env.VUE_APP_HERE_ROUTING_API,
    url: '/v8/routes',
    method: 'get',
    params: {
      ...params,
      apikey: process.env.VUE_APP_HERE_MAP_KEY,
      return: 'summary',
      transportMode: 'truck',
      routingMode: 'fast',
      'avoid[features]': 'dirtRoad,difficultTurns'
    },
    headers: {
      'disable-token': true
    }
  })
}
